import { render, staticRenderFns } from "./InventoryMain.vue?vue&type=template&id=3e4e15ca&scoped=true"
import script from "./InventoryMain.vue?vue&type=script&lang=js"
export * from "./InventoryMain.vue?vue&type=script&lang=js"
import style0 from "./InventoryMain.vue?vue&type=style&index=0&id=3e4e15ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e15ca",
  null
  
)

export default component.exports